import React from 'react';
import img1 from '../../../../img/how-it-works-requirements/devices.png';
import img2 from '../../../../img/how-it-works-requirements/devices2.png';
import img3 from '../../../../img/how-it-works-requirements/wi-fi.svg';
import img4 from '../../../../img/how-it-works-requirements/browser-logos.png';
import img5 from '../../../../img/how-it-works-requirements/flash-player-logo.svg';
import img6 from '../../../../img/how-it-works-requirements/skype-logo.svg';

const WhatDoINeed = () => (
  <span>
    <h1 className='u-text-center'>What do I need?</h1>

    <div className='l-container l-container--x-narrow'>
      <ul className='requirements-list'>
        <li className='island island--outline'>
          <h2>1. A computer, tablet or smart phone</h2>
          <img src={img1} alt='Computer' />
          <a href='/terms/requirements' className='button button--xs button--neutral' target='_blank'>Minimum requirments</a>
        </li>

        <li className='island island--outline'>
          <h2>2. A webcam</h2>
          <img src={img2} alt='Webcam' />
        </li>

        <li className='island island--outline'>
          <h2>3. The technical stuff you'll need</h2>
          <div className='l-columns l-columns--2 requirements-list__grid'>
            <div>
              <img src={img3} alt='Broadband logo' />
              <p>Broadband (min of 2Mbps download and 0.5Mbps upload)</p>
              <a href='http://www.speedtest.net/' className='button button--xs button--neutral' target='_blank' rel='noopener noreferrer'>Check your speed</a>
            </div>

            <div>
              <img src={img4} alt='Browser logos' />
              <p>One of these internet browsers</p>
              <a href='https://www.google.com/chrome/browser/desktop/' className='button button--xs button--neutral' target='_blank' rel='noopener noreferrer'>Download Chrome</a>
            </div>

            <div>
              <img src={img5} alt='Flash logo' />
              <p>Adobe Flash Player</p>
              <a href='http://get.adobe.com/flashplayer' className='button button--xs button--neutral' target='_blank' rel='noopener noreferrer'>Get Flash Player</a>
            </div>

            <div>
              <img src={img6} alt='Skype logo' />
              <p>You will need Skype</p>
              <a href='https://www.skype.com/en/download-skype/skype-for-computer/' className='button button--xs button--neutral' target='_blank' rel='noopener noreferrer'>Download Skype</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </span>
);

export default WhatDoINeed;



// WEBPACK FOOTER //
// ./src/views/Main/Tour/WhatDoINeed/index.js